'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/layout/style/css.js
// module id = 2IeB
// module chunks = 0